document.addEventListener('DOMContentLoaded', () => {
    const menuButton = document.querySelector('.menu_btn');
    const closeButton = document.querySelector('.close_btn');
    const navMenu = document.querySelector('.nav_menu');

    if (menuButton && navMenu) {
        menuButton.addEventListener('click', () => {
            navMenu.classList.toggle('active');
        });
    }
    if (closeButton && navMenu) {
        closeButton.addEventListener('click', () => {
            navMenu.classList.toggle('active');
        });
    }
    window.addEventListener("resize", () => { navMenu.classList.remove('active') });

    const accordionContainers = document.querySelectorAll('[data-accordion]');
    
    accordionContainers.forEach(container => {
        const accordionItems = container.querySelectorAll('.accordion_item');
    
        accordionItems.forEach(item => {
            const title = item.querySelector('.accordion_title');
    
            if (title) {
                title.addEventListener('click', () => {
                    // Usuwanie klasy 'active' z innych elementów
                    accordionItems.forEach(otherItem => {
                        if (otherItem !== item) {
                            otherItem.classList.remove('active');
                        }
                    });
    
                    // Dodanie klasy 'active' do klikniętego elementu
                    item.classList.toggle('active');
                });
            }
        });
    });

    // Tests Block - Nested Accordions
    const testsAccordionContainers = document.querySelectorAll('[data-tests-accordion]');
    
    testsAccordionContainers.forEach(container => {
        // Main category accordions (level 1)
        const categoryItems = container.querySelectorAll('.tests-accordion_item.category-level');
        
        categoryItems.forEach(categoryItem => {
            const categoryTitle = categoryItem.querySelector('.tests-accordion_title.category-title');
            
            if (categoryTitle) {
                categoryTitle.addEventListener('click', (e) => {
                    // Prevent event from bubbling to nested accordions
                    e.stopPropagation();
                    
                    // Close other categories (optional - remove if you want multiple open)
                    categoryItems.forEach(otherCategory => {
                        if (otherCategory !== categoryItem) {
                            otherCategory.classList.remove('active');
                        }
                    });
                    
                    // Toggle current category
                    categoryItem.classList.toggle('active');
                });
            }

            // Nested test accordions (level 2) within this category - only with content
            const testItems = categoryItem.querySelectorAll('.tests-accordion_item.test-level.has-content');
            
            testItems.forEach(testItem => {
                const testTitle = testItem.querySelector('.tests-accordion_title.test-title');
                
                if (testTitle) {
                    testTitle.addEventListener('click', (e) => {
                        // Prevent event from bubbling to parent accordion
                        e.stopPropagation();
                        
                        // Close other tests in the same category
                        testItems.forEach(otherTest => {
                            if (otherTest !== testItem) {
                                otherTest.classList.remove('active');
                            }
                        });
                        
                        // Toggle current test
                        testItem.classList.toggle('active');
                    });
                }
            });
        });
    });
});